"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _iconButton = _interopRequireDefault(require("../icon-button"));
var _socialMediaFacebook = _interopRequireDefault(require("../../icons/social-media-facebook"));
var _socialMediaInstagram = _interopRequireDefault(require("../../icons/social-media-instagram"));
var _socialMediaPinterest = _interopRequireDefault(require("../../icons/social-media-pinterest"));
var _socialMediaSpotify = _interopRequireDefault(require("../../icons/social-media-spotify"));
var _socialMediaX = _interopRequireDefault(require("../../icons/social-media-x"));
var _socialMediaYoutube = _interopRequireDefault(require("../../icons/social-media-youtube"));
var _excluded = ["linkItems", "className", "listItemClassName"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var iconMap = {
  facebook: _socialMediaFacebook["default"],
  instagram: _socialMediaInstagram["default"],
  pinterest: _socialMediaPinterest["default"],
  spotify: _socialMediaSpotify["default"],
  x: _socialMediaX["default"],
  youtube: _socialMediaYoutube["default"]
};

/**
 * Icons available:
 - Facebook
 - Instagram
 - Pinterest
 - Spotify
 - X
 - Youtube
 *
 * To select the icons you want, send an object through `linkItems` props array.
 *
 * `...otherProps` are sent to `IconButton`
 */
var SocialMediaIconGroup = function SocialMediaIconGroup(_ref) {
  var _ref$linkItems = _ref.linkItems,
    linkItems = _ref$linkItems === void 0 ? [] : _ref$linkItems,
    className = _ref.className,
    listItemClassName = _ref.listItemClassName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "flex flex-wrap ".concat(className || '')
  }, linkItems.map(function (_ref2, i) {
    var _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? '' : _ref2$name,
      url = _ref2.url,
      ariaLabel = _ref2.ariaLabel;
    var socialMediaName = name === null || name === void 0 ? void 0 : name.toLowerCase();
    if (!iconMap[socialMediaName]) return null;
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: listItemClassName,
      key: i
    }, /*#__PURE__*/_react["default"].createElement(_iconButton["default"], _extends({
      ariaLabel: ariaLabel || socialMediaName,
      className: "inline-block",
      href: url,
      path: iconMap[socialMediaName],
      size: "32px"
    }, otherProps)));
  }));
};
SocialMediaIconGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Applied to the `<ul />` parent. */
  className: _propTypes["default"].string,
  /** Array of objects that maps to each icon. Each object needs a `name`, `ariaLabel`, and `url`. `AriaLabel` defaults to `name` if not provided. */
  linkItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string.isRequired,
    ariaLabel: _propTypes["default"].string
  })).isRequired,
  /** Applied to the `<li />` surrounding the IconButton */
  listItemClassName: _propTypes["default"].string
} : {};
SocialMediaIconGroup.defaultProps = {
  className: '',
  listItemClassName: ''
};
SocialMediaIconGroup.displayName = 'SocialMediaIconGroup';
var _default = exports["default"] = SocialMediaIconGroup;